export default {
  noSupport: {
    en: 'Your browser does not support the video tag.',
  },
}
